import application from 'application/application';

import template from './publications.template.html';

import controller from './publications.controller';

import submenuTemplate from './partials/submenu/submenu.template.html';

import submenuController from './partials/submenu/submenu.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default.publications', {
				url: '/publicacoes?paginaAtual&q&visualizada&favorita&arquivada&dataPublicacao&idPalavraChave&idDiario&vara&comarca',
				views: {
					'default@root.default': {
						templateUrl: template,
						controller
					},
					'submenu@root.default': {
						templateUrl: submenuTemplate,
						controller: submenuController
					}
				},
				data: {
					documentTitle: 'Publicações'
				}
			});

	}]);
